import { render, staticRenderFns } from "./Roles-Detail.vue?vue&type=template&id=4d8b4e34"
import script from "./Roles-Detail.vue?vue&type=script&lang=js"
export * from "./Roles-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports